import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/compliance/[type]/components/ScrollIntoAreaTarget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/ui/tabs.tsx");
